import { BiSolidCameraPlus, BiBuildings, BiLogoMicrosoft, BiSolidBaguette, BiSolidBuildings } from "react-icons/bi";
import {
    BsFileEarmarkWord
} from "react-icons/bs";
import {
    ProfileManagementIcon, CompanyManagementIcon, ProjectManagementIcon,
    TaskManagementIcon, BrandIcon, CameraSettingsIcon, ErrorEmailIcon,
    UserPermissionsIcon, TimeLapseCameraIcon, HomeIcon,
    LiveCameraIcon,
    AICameraIcon
} from '../components/icons/CustomIcons';
import { TbBrandWindowsFilled } from "react-icons/tb";
import { FaMicrosoft } from "react-icons/fa6";

// import Profile from "../pages/auth/Profile"
import Login from "../pages/auth/Login"
import Dashboard from "../pages/dashboard/Dashboard";
import Role from "../pages/permissions/Role"
import Profile from "../pages/auth/Profile";
// import UserRole from "../pages/permissions/UserRole";
// import UserView from "../pages/users/View";
import PackageView from '../pages/packages/View';

import UserManagementView from '../pages/users/View';
import UserPermissionView from '../pages/userperm/View';

import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";

import DocumentView from "../pages/document/View";
import DocumentForm from "../pages/document/Form";
import Documents from "../pages/document/Documents";
import FileUploader from "../pages/document/FileUpload";
import History from "../pages/document/History";
// import NotifyView from "../pages/notify/View";
import {
    HelpIcon, PackageIcon, PermissionsIcon,
} from "../components/icons/CustomIcons";
import { Project24, Usermangement24, Videoarchives24 as VideoArchives24, Imagearchives24 as ImageArchives24, Timelapsecamera24 } from "../components/icons/Icons";


export const anonyMenus = [
    {
        to: "/",
        component: <Login />,
    },
    {
        to: "/login/",
        component: <Login />,
    },
    {
        to: "/forgot-password/",
        component: <ForgotPassword />,
    },
    {
        to: "/reset-password/",
        component: <ResetPassword />,
    },

]
const iconColor = "#5D6C7B"
export const menus = [
    {
        icon: <HomeIcon variant="filled" color={iconColor} />,
        label: "Dashboard",
        to: "/",
        proxyto: [
            { to: "/dashbord/", component: <Dashboard /> },
            { to: "/profile/", component: <Profile /> }, /*profile is not in menu so setup in proxyto*/
        ],
        component: <Dashboard />,
        permission: "*",
    },

    {
        icon: <BsFileEarmarkWord size={24} color={iconColor} />,
        label: "Documents",
        to: "/repository/",
        component: <DocumentView />,
        permission: "*",
        proxyto: [
            { to: "/repository/:id", component: <DocumentView /> },
            { to: "/commits/", component: <Documents /> },
            { to: "/repository/documents/:id", component: <Documents /> },
            { to: "/history/", component: <History /> },
            {
                to: "/fileupload/", component: <FileUploader back={() => {
                    document.location.href = "#/repository/"

                }} />
            },
        ],
    },
    // {
    //     icon: <BsFileArrowDown size={24} color={iconColor} />,
    //     label: "File Upload",
    //     to: "/fileupload/",
    //     component: <FileUploader />,
    //     permission: "*",
    // },

    {
        icon: <Usermangement24 size={24} viewBox="0 0 24 24" variant="filled" color={iconColor} />,
        label: "Employes",
        to: "/user-management/",
        component: <UserManagementView />,
        permission: "view_user",
        hide: true,
    },

    {
        icon: <PermissionsIcon size={24} variant="filled" color={iconColor} />,
        label: "More...",
        to: "/role/",
        component: <Role />,
        permission: "view_permission",
        hide: true,
        submenus: [
            {
                icon: <PermissionsIcon size={24} variant="filled" color={iconColor} />,
                label: "Permissions",
                to: "/role/",
                component: <Role />,
                permission: "view_permission",
            },
            {
                icon: <UserPermissionsIcon size={24} variant="filled" color={iconColor} />,
                label: "User <br/>Permission",
                to: "/user-permission/",
                component: <UserPermissionView />,
                permission: "view_permission",

            },

        ]
    },
    {
        icon: <HelpIcon size={24} variant="filled" color={iconColor} />,
        label: "Helps",
        to: "/help/",
        component: <></>,
        permission: "*",
    },
]